import { render, staticRenderFns } from "./cakeCode.vue?vue&type=template&id=4b438c30&scoped=true&"
import script from "./cakeCode.vue?vue&type=script&lang=js&"
export * from "./cakeCode.vue?vue&type=script&lang=js&"
import style0 from "./cakeCode.vue?vue&type=style&index=0&id=4b438c30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b438c30",
  null
  
)

export default component.exports